// extracted by mini-css-extract-plugin
export default {"header-page":"MinigridListPage_header-page__VZixq","header-page__search":"MinigridListPage_header-page__search__ulf4o"};